import {Xpedition} from './Xpedition';
export default Xpedition;
